import type { SettingsProviderProps } from '../types';

import { useMemo } from 'react';

import { SettingsContext } from './settings-context';
import { defaultSettings } from '../settings-config';

// ----------------------------------------------------------------------

export function SettingsProvider({ children }: SettingsProviderProps) {
  const memoizedValue = useMemo(() => ({ state: defaultSettings }), []);

  return <SettingsContext value={memoizedValue}>{children}</SettingsContext>;
}
